import type { Messages } from "@prop/i18n";
import type en from "../en/config";

export default {
  label: "Configura tu challenge",
  loading: "Cargando el catálogo…",
  empty: "Aún no hay un programa para esta combinación.",
  product: {
    label: "Producto",
    markets: "FX y CFD",
    futures: "Futuros",
    perps: "Cripto 24/7",
  },
  productNote: {
    markets: "Divisas, metales e índices",
    futures: "CME, NYMEX y COMEX",
    perps: "Abierto 24/7, también fines de semana",
  },
  instruments: "{n} instrumentos",
  evaluation: {
    label: "Evaluación",
    instant: "Instant",
    "1step": "1 fase",
    "2step": "2 fases",
    sprint: "Sprint",
  },
  size: {
    label: "Tamaño de cuenta",
    recommended: "Recomendado",
    cards: "Tarjetas",
    table: "Tabla",
    view: "Vista",
  },
  type: { label: "Tipo de challenge" },
  tag: {
    noDaily: "Sin drawdown diario",
    lowestTarget: "Objetivo de ganancia más bajo",
    noConsistency: "Sin regla de consistencia",
    cheapest: "El más económico",
    widest: "El drawdown más amplio",
    fullSplit: "Hasta 100 % de reparto de ganancias",
    turbo: "Turbo disponible",
    window: "Una sesión de {h} horas",
  },
  model: {
    label: "Modelo de challenge",
    classic: "Classic",
    turbo: "Turbo",
    futClassic: "Sin cuota de activación",
    futTurbo: "Estándar",
    classicNote: "Pagas una vez, nada al pasar a funded",
    plusFee: "+ {fee} al pasar a funded",
  },
  rules: {
    all: "Todas las condiciones",
    allHide: "Menos condiciones",
    extra: "Más reglas",
    title: "Reglas de la cuenta",
    split: "Reparto de ganancias",
    target: "Objetivo de ganancia",
    daily: "Drawdown diario",
    max: "Drawdown máximo",
    reward: "Bono por rendimiento",
    rewardNote: "una vez, tras un crecimiento del {g} % en funded",
    tradeLoss: "Pérdida por operación",
    tradeLossNote: "cuenta funded, también operaciones abiertas",
    none: "Ninguno",
    less: "Bajar {k}",
    more: "Subir {k}",
  },
  reward: {
    scaling: "Escalado",
    scalingCell: "+{step} % cada {months} meses",
    scalingNote: "hasta {max} en la misma cuenta",
    title: "Información de payouts",
    cycle: "Ciclo de payouts",
    cycles: { on_demand: "A pedido", weekly: "Semanal", bi_weekly: "Quincenal", monthly: "Mensual" },
    consistency: "Consistencia",
    bestDay: "Mejor día ≤ {v} %",
    evalConsistency: "evaluación: mejor día ≤ {v} %",
    days: "Días mín. de trading",
    daysNote: "días con ganancia ≥ {v}",
    rewardsIn: "Primer payout en",
    rewardsInDays: "{n} días",
    onDemand: "A pedido",
    feeRefund: "Reembolso de la cuota",
    feeRefundCell: "{pct} % con el payout #{n}",
    cap: "Tope del primer payout",
    minTrades: "Operaciones cerradas mín.",
    bestTrade: "Mejor operación",
    bestTradeCell: "≤ {v} % de la ganancia",
    payouts: "Payouts por cuenta",
    once: "Uno",
  },
  details: {
    title: "Detalles de la cuenta",
    time: "Límite de tiempo",
    unlimited: "Ilimitado",
    days: "{n} días",
    window: "{h} h desde la primera operación",
    tradingDays: "Días de trading máx.",
    leverage: "Apalancamiento",
    instruments: "Instrumentos",
    drawdownType: "Tipo de drawdown",
    dayEnds: "El día de trading termina",
    contracts: "Contratos máx.",
    contractsCell: "{n} por instrumento",
    flat: "Posiciones cerradas",
    flatCell: "a diario a las {time} {city}",
    news: "Trading en noticias",
    weekend: "Mantener el fin de semana",
    allowed: "Permitido",
    newsCell: "Sin operaciones nuevas ±{n} min (funded)",
    weekendCell: "Cierre vie 16:55 Nueva York (funded)",
    coach: "Coach IA",
    included: "Incluido",
    activation: "Cuota de activación",
    activationCell: "{fee} al pasar a funded",
  },
  summary: {
    pick: "Elige tu bono",
    offNote: "ya incluido en el precio",
    save: "Ahorra {v}",
    currency: "USD",
    offer: "Oferta limitada",
    off: "{v} % DTO.",
    buyGet: "COMPRA 1 Y LLEVA {n}",
    resets: "{n} REINICIO GRATIS",
    start: "Iniciar challenge",
    fullRules: "Reglas completas",
    payWith: "Paga en cripto: stablecoins (USDT, USDC) o monedas principales. La cuenta se abre en cuanto se confirma el pago.",
    oneTime: "pago único",
    whenFunded: "+ {fee} al pasar a funded",
    more: "Qué significan",
  },
  tips: {
    buyGetShort: "+{n} cuentas, se abren con tus payouts",
    resetShort: "Un reinicio gratis si la evaluación falla",
    off: "El precio de hoy está un {v} % por debajo del precio de lista. Ya está aplicado — no hay código que ingresar.",
    buyGet: "Con esta cuenta vienen {n} cuentas más del mismo plan, tamaño y opciones. Se abren una por una: la primera con tu primer payout pagado, la siguiente con el siguiente.",
    reset: "Si la evaluación no sale bien, reiniciamos tu cuenta gratis con su balance inicial — mismo plan, nada que volver a comprar.",
  },
  table: {
    size: "Tamaño",
    price: "Precio",
    target: "Objetivo",
    daily: "Diario",
    max: "Máx.",
    split: "Reparto",
    fee: "Al pasar a funded",
    pick: "Elegir {size}",
  },
  buy: {
    config: "Configuración",
    split: "Reparto de ganancias",
    model: "Modelo",
    activation: "Cuota de activación",
    activationNote: "se cobra cuando la cuenta pasa a funded",
    list: "Precio de lista",
    offers: "Incluye",
  },
  offers: {
    title: "Ofertas de esta compra",
    lead: "Lo que vino con la compra y cuándo se abre.",
    extra: "Cuenta extra #{n}",
    locked: "Se abre con el payout pagado #{n}",
    opened: "Abierta",
    open: "Abrirla",
    void: "Cancelada",
    reset: "Reinicio gratis",
    resetReady: "La evaluación terminó. Reiníciala con el balance inicial y las mismas reglas, gratis.",
    resetUse: "Usar reinicio",
    resetDone: "Reiniciada. Abriendo la nueva cuenta…",
    resetHint: {
      not_failed: "Disponible si esta evaluación falla",
      not_evaluation: "No disponible en una cuenta funded",
      no_free_reset: "Ya usado",
      no_offer: "Esta cuenta no incluye reinicio",
      already_restarted: "Esta cuenta ya se reinició",
    },
    activation: "Cuota de activación",
    activationDue: "{fee} a pagar cuando la cuenta pase a funded",
    paidReset: "Reinicio tras un incumplimiento",
    paidResetReady: "Reinicia esta cuenta con su balance inicial, mismas reglas y tamaño, por {fee}.",
    paidResetUse: "Comprar reinicio · {fee}",
    paidResetHint: { not_failed: "Disponible tras un incumplimiento", already_restarted: "Esta cuenta ya se reinició" },
    haircut: "Penalización por reinicio",
    haircutText: "Esta cuenta se reinició tras infringir una regla: cada payout en ella se paga un {pct} % menos, durante toda su vida.",
    config: "Configuración",
    split: "Reparto de ganancias {v} %",
  },
  scaling: {
    title: "Plan de escalado",
    lead: "Cada {months} meses: +{step} % del tamaño de la cuenta, hasta {max}. Misma cuenta, mismas condiciones.",
    period: "Pasan {months} meses",
    periodCell: "termina {at}",
    growth: "Crecimiento ≥ {pct} %",
    growthCell: "{v} de {need}",
    payouts: "Payouts pagados",
    payoutsCell: "{n} de {need}",
    profit: "Cuenta con ganancia",
    next: "Siguiente tamaño",
    up: "Escalar a {size}",
    max: "La cuenta está en el tamaño máximo.",
    history: "Escalada {from} → {to}",
  },
} satisfies Messages<typeof en>;
